import {
  addMissingTableFilters,
  getTextOccurrencesOnListByKeyName,
} from "./objects";

export const USER_STATUS_TYPES = {
  Approved: "ready",
  Pending: "pending",
  Disabled: "draft",
};
export const USER_STATUSES = {
  Approved: "Approved",
  Pending: "Pending",
  Disabled: "Disabled",
};

export const getUsersTableFilters = (users) => {
  const filtersWithData = getTextOccurrencesOnListByKeyName(
    users,
    "statusText"
  );
  const possibleFiltersTexts = Object.keys(USER_STATUSES);
  return addMissingTableFilters(filtersWithData, possibleFiltersTexts);
};

export const checkAdminUserStatus = (enabled, userStatus) => {
  if (userStatus === "FORCE_CHANGE_PASSWORD") return USER_STATUSES.Pending;
  if (!enabled) return USER_STATUSES.Disabled;
  return USER_STATUSES.Approved;
};
